import { InspectionPdfDetailDto } from '@artemis-software/wr-api';
import InspectionPdfTypeEnum = InspectionPdfDetailDto.InspectionPdfTypeEnum;

export interface PdfOption {
  type: InspectionPdfTypeEnum;
  label: string;
  // Nur PDFs koennen an die Begehungs-E-Mail angehaengt werden
  emailRequirable?: boolean;
  horaPassAppendable?: boolean;
}

export const defaultPdfOptions: PdfOption[] = [
  { type: InspectionPdfTypeEnum.Shortlist, label: 'Shortlist' },
  { type: InspectionPdfTypeEnum.Longlist, label: 'Longlist' },
  { type: InspectionPdfTypeEnum.Coversheet, label: 'Deckblatt' },
  { type: InspectionPdfTypeEnum.BuildingEquipments, label: 'TGAs' },
  { type: InspectionPdfTypeEnum.CertificateSheet, label: 'Zertifikat' },
  { type: InspectionPdfTypeEnum.BuildingEquipmentsSchloss, label: 'TGAs Spielplatzgeräte' },
  { type: InspectionPdfTypeEnum.CertificateSheetSchloss, label: 'Zertifikat Spielplatzgeräte' },
  { type: InspectionPdfTypeEnum.ObjectSafetyReport, label: 'Objektsicherheitsbericht' },
  { type: InspectionPdfTypeEnum.Schadstellenplan, label: 'Schadstellenplan' },
  { type: InspectionPdfTypeEnum.ObjectSafetyList, label: 'Objektsicherheitsliste (Excel)', emailRequirable: false, horaPassAppendable: false },
];
